export const HOMEPAGE_TITLE = 'Zara Mills – Set Decoration'
export const HOMEPAGE_DESCRIPTION = 'Junior Assistant Set Decorator'

/**
 * Search and social metadata for the homepage.
 * Google uses the description when the page does not otherwise supply one.
 */
export function homepageHead() {
  return {
    title: HOMEPAGE_TITLE,
    meta: [
      { name: 'description', content: HOMEPAGE_DESCRIPTION },
      { property: 'og:title', content: HOMEPAGE_TITLE },
      { property: 'og:description', content: HOMEPAGE_DESCRIPTION },
    ],
  }
}
